import request from "@/network/request";

// 山大一问卷提交
export function answerSave(data) {
  return request({
    url: "/nutrition/diagnosis/wechat/questionnaire/answer ",
    method: "post",
    data,
  });
}
